// 首字母大写
export function capitalize(str = '') {
  if (!str) {
    return ''
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function sleep(time: number) {
  return new Promise(resolve => setTimeout(resolve, time))
}

// 本地化价格
export function localPriceFormat(value: number): string {
  if (value === undefined || value === null) {
    return ''
  }
  const currency = localStorage.getItem('tapon_currency') || 'USD'
  const locale = localStorage.getItem('tapon_locale') || 'us-US'
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value / 100)
}
// 生成 codeVerifier
export function getCodeVerifier(): string {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-'
  let codeVerifier = ''
  const charsetLength = charset.length
  const length = 64

  // Randomly generate the string
  for (let i = 0; i < length; i++) {
    codeVerifier += charset.charAt(Math.floor(Math.random() * charsetLength))
  }

  return codeVerifier
}
